import React, { memo } from 'react';
import { User, Mail, Phone, Briefcase, Building } from 'lucide-react';
import { Modal, ModalHeader, ModalBody } from './ui/Modal';
import './ContactModal.css';

const ContactModal = memo(({ contact, isOpen, onClose }) => {
  // CONDITIONAL RENDERING AFTER ALL HOOKS
  if (!isOpen || !contact) {
    return null;
  }

  return (
    <Modal trackAs="ContactModal" isOpen={isOpen} onClose={onClose} size="md">
      {/* Header */}
      <ModalHeader>
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">{contact.name}</h2>
          {contact.role && <span className="contact-role">{contact.role}</span>}
        </div>
      </ModalHeader>

      {/* Contact Details */}
      <ModalBody>
        <div className="contact-details">
          <div className="details-grid">
            <div className="detail-item">
              <User size={20} />
              <div>
                <label>Full Name</label>
                <span>{contact.name}</span>
              </div>
            </div>

            {contact.email && (
              <div className="detail-item">
                <Mail size={20} />
                <div>
                  <label>Email</label>
                  <a href={`mailto:${contact.email}`} className="contact-email">
                    {contact.email}
                  </a>
                </div>
              </div>
            )}

            {contact.phoneNumber && (
              <div className="detail-item">
                <Phone size={20} />
                <div>
                  <label>Phone Number</label>
                  <a href={`tel:${contact.phoneNumber}`} className="contact-phone">
                    {contact.phoneNumber}
                  </a>
                </div>
              </div>
            )}

            {contact.role && (
              <div className="detail-item">
                <Briefcase size={20} />
                <div>
                  <label>Role</label>
                  <span>{contact.role}</span>
                </div>
              </div>
            )}

            <div className="detail-item">
              <Building size={20} />
              <div>
                <label>Associated Client</label>
                <span>Client ID: {contact.clientId || 'Unknown'}</span>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
});

ContactModal.displayName = 'ContactModal';

export default ContactModal;